import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelationReportComponent } from './cancelation-report.component';
import { APP_ROUTES_MAIN } from './cancelation-report.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';
import { SharedModule } from '../../shared/shared.module';
import { DataTablesModule } from 'angular-datatables';

@NgModule({
  declarations: [
    CancelationReportComponent,
    CreateComponent,
    ListComponent
  ],
  imports: [
    APP_ROUTES_MAIN,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DataTablesModule
  ]
})
export class CancelationReportModule { }
